<template>
  <label class="input_field field_wrap" :class="classWrapper">
        {{label}}
        <input
        :value="value"
        class="font_regular font_500 text_14 mt_8"
        :class="classInput"
        type="text"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
        >
        <span v-if="error" class="err_msg error">
        {{errorMessage}}
        </span>
    </label>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        errorMessage: {
            type: String,
            default: ''
        },
        error: {
            type: Boolean,
            default: false
        },
        classWrapper: {
            type: String,
            default: ''
        },
        classInput: {
            type: String,
            default: ''
        },
    }
}
</script>


<style lang="scss" scoped>
.field_wrap{
    position: relative;
}
.error{
  color: red;
}
.err_msg{
  position: absolute;
  bottom: -17px;
}
</style>